import React, { useEffect, useState } from "react";

// components
import { Button, Card, CardBody, CardHeader, Form, Row, Col, Spinner } from "reactstrap";
import MaterialTable from 'material-table';
import Select from 'react-select';

// style
import { table_translate, table_style } from "constants/MaterialTable.js";

// views
import UsuarioFicha from "./UsuarioFicha";

// helpers
import { showMessage } from "../../helpers/message.js";

// api
import usuario_api from "../../api/usuario_api.js";

// Estilo do react-select extraído do render — evita recriar o objeto a cada render (L-2).
const SELECT_STYLES = { menuPortal: base => ({ ...base, zIndex: 9999 }) };

export default function UsuarioLista() {

  const [showLoading, setshowLoading] = React.useState(false);

  const [list_table, set_list_table] = React.useState([]);
  const [rowEdit, set_rowEdit] = React.useState(null);
  const [showDetail, set_showDetail] = React.useState(false);
  const [isDisable, set_isDisable] = useState(true);

  const options_status = [
    { label: "Ativo", value: "Ativo" },
    { label: "Inativo", value: "Inativo" },
    { label: "Todos", value: "Todos" }
  ];
  const [status_filtro, set_status_filtro] = useState(options_status[0]);

  const handleAdd = () => {
    set_rowEdit(null);
    set_showDetail(true);
  }

  const handleEdit = (rowData) => {
    setshowLoading(true);
    usuario_api.getItem(rowData.usuario_Id).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_rowEdit(result.data);
        set_showDetail(true); 
      }
    });    
  }

  const handleReturn = () => {
    set_rowEdit(null);
    set_showDetail(false);
    loadList(status_filtro.value);
  }

  const loadList = (status) => {
    setshowLoading(true);
    usuario_api.getAll(status)
      .then(result => {
        if (result.status !== 200) {
          showMessage("Aviso", result.message, 'error', null);
        }
        else {
          set_list_table(result.data);
        }
      })
      .catch(() => {
        showMessage("Aviso", "Falha na comunicação com o servidor.", 'error', null);
      })
      .finally(() => {
        setshowLoading(false);
      });
  }

  const handleChangeStatusFiltro = (option) => {
    set_status_filtro(option);
    loadList(option.value);
  }

  useEffect(() => {
    usuario_api.getFuncionalidadeAcaoLiberada("Usuarios", "Editar").then((result) => {set_isDisable(!result);});

    loadList(status_filtro.value);
  }, []);

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <Spinner></Spinner>
          </div>
        </div>
      }
      <div className={showDetail ? "d-none" : "content"}>
        <Row>
          <Col md="12">
            {!isDisable && <Button color="default" onClick={handleAdd}><i className="fa fa-plus"></i>  Novo Usuário</Button>}
            <Card>
              <CardHeader>
                <h4 className="titleCard">Lista de Usuários</h4>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row className="mb-4">
                    <Col md="3">
                      <label className="form-control-label">Status</label>
                      <Select
                        name="status_filtro"
                        options={options_status}
                        value={status_filtro}
                        onChange={handleChangeStatusFiltro}
                        styles={SELECT_STYLES}
                        menuPortalTarget={document.body}
                      />
                    </Col>
                  </Row>
                  <MaterialTable style={{ minHeight: "auto" }}
                    title=""
                    columns={[
                      { title: 'Login', field: 'login' },
                      { title: 'Nome', field: 'nome' },
                      { title: 'Perfil', field: 'perfil' },
                      { title: 'Status', field: 'status' }
                    ]}
                    data={list_table}
                    isLoading={false}
                    options={{
                      ...table_style,
                      filtering: false,
                      exportButton: true
                    }}
                    actions={[
                      {
                        icon: 'search',
                        tooltip: 'Visualizar Registro',
                        onClick: (event, rowData) => handleEdit(rowData)
                      }
                    ]}
                    localization={table_translate}
                  />
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      {showDetail &&
        <UsuarioFicha item={rowEdit} handleReturn={handleReturn}></UsuarioFicha>
      }

    </>

  );
}